import React from 'react';
import { Box, Typography } from '@mui/material';

const SurveyHeader = ({ surveyName, surveyDescription, logoSrc, colors }) => {
    return (
        <Box
            sx={{
                mb: 5,
                p: 4,
                background: `linear-gradient(135deg, ${colors.racineRedDark}, #B88552)`,
                borderRadius: '12px',
                boxShadow: '0 6px 15px rgba(0, 0, 0, 0.2)',
                textAlign: 'center',
                color: 'white',
            }}
        >
            <Box sx={{ mb: 3 }}>
                <img
                    src={logoSrc}
                    alt="Survey Logo"
                    style={{ maxWidth: '120px', width: '100%', height: 'auto' }}
                />
            </Box>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    letterSpacing: '2px',
                    mb: 2,
                    //fontSize: '2rem',
                }}
            >
                {surveyName}
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    fontSize: '1.2rem',
                    fontWeight: '300',
                    maxWidth: '600px',
                    margin: '0 auto',
                }}
            >
                {surveyDescription}
            </Typography>
        </Box>
    );
};

export default SurveyHeader;
